import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {SuggestionHotelCardSkeleton} from 'widgets/components/HotelCarousel/HotelCard/SuggestionHotelCardSkeleton'

const SkeletonContainer = styled.div(
  ({theme}) => css`
    min-height: 394px;
    display: flex;
    gap: ${theme.layout.spacing.s500}px;
    overflow: hidden;
  `
)

export const HotelCardsSkeleton = () => (
  <SkeletonContainer>
    {[...Array(7)].map((_, index) => (
      <SuggestionHotelCardSkeleton key={index} />
    ))}
  </SkeletonContainer>
)
